import * as fromDatatype from '../datatype-library/index';

export interface bl_catalog_login_subject_link_import_file_helper_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
    catalogue_code: fromDatatype.VarcharDatatypeInterface;
    catalogue_hdr_guid: fromDatatype.GuidDataFieldInterface;
    catalogue_validate_error: fromDatatype.VarcharDatatypeInterface;
    user_id: fromDatatype.VarcharDatatypeInterface;
    subject_guid: fromDatatype.GuidDataFieldInterface;
    subject_validate_error: fromDatatype.VarcharDatatypeInterface;
    rank: fromDatatype.VarcharDatatypeInterface;
    catalog_login_link_exist_guid: fromDatatype.VarcharDatatypeInterface;
    catalog_login_link_guid: fromDatatype.VarcharDatatypeInterface;
    short_error_message: fromDatatype.TextDatatypeInterface;
    error_stack_trace: fromDatatype.TextDatatypeInterface;
    line_number: fromDatatype.IntegerDatatypeInterface;
    validated: boolean;
    processed: boolean;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_catalog_login_subject_link_import_file_helper_RowClass implements bl_catalog_login_subject_link_import_file_helper_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
    catalogue_code: fromDatatype.VarcharDatatypeInterface;
    catalogue_hdr_guid: fromDatatype.GuidDataFieldInterface;
    catalogue_validate_error: fromDatatype.VarcharDatatypeInterface;
    user_id: fromDatatype.VarcharDatatypeInterface;
    subject_guid: fromDatatype.GuidDataFieldInterface;
    subject_validate_error: fromDatatype.VarcharDatatypeInterface;
    rank: fromDatatype.VarcharDatatypeInterface;
    catalog_login_link_exist_guid: fromDatatype.VarcharDatatypeInterface;
    catalog_login_link_guid: fromDatatype.VarcharDatatypeInterface;
    short_error_message: fromDatatype.TextDatatypeInterface;
    error_stack_trace: fromDatatype.TextDatatypeInterface;
    line_number: fromDatatype.IntegerDatatypeInterface;
    validated: boolean;
    processed: boolean;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}